import React from "react"


function LastPart() {
    return (
        <div>

            <div>
                <div>
                    <p style={{fontSize:"13px",color:"#7F9CAD",fontWeight:"bold", marginRight:"49%"}}>© 2021  Clockify <a style={{marginLeft:"10px"}} href>Cookies</a>  <a style={{marginLeft:"10px"}} href>Terms</a>  <a style={{marginLeft:"10px"}} href> Privacy </a> <a style={{marginLeft:"10px"}} href>Security</a>  </p>
                </div>
                <div style={{ display: "flex",marginLeft:"14.5%"}}>
                    <div style={{fontSize:"12px",color:"#7F9CAD",fontWeight:"bold"}}>
                        COING Inc, 2100 Geng Road, Suite 210, Palo Alto, CA 94303, United States
                </div>
                    <div style={{fontSize:"12px",color:"#7F9CAD",fontWeight:"bold",marginLeft:"42%"}}>
                        +1 (855) 738 8741
                </div>
                </div>
            </div>

        </div>
    )
}


export { LastPart }